import $ from 'jquery';
import './lib/jquery.waypoints.min.js';
import './plugins/jquery.slick.min.js';
import './plugins/jquery.magnific-popup.min.js';
import './plugins/jquery.matchHeight.js';
import './plugins/jquery.easyResponsiveTabs.js';
import './plugins/jquery.sumoselect.min.js';
import './plugins/jquery.nicefileinput.min.js';
import './plugins/jquery.prettyCheckable.min.js';
import './plugins/jquery.infinite.min.js';

import utils from './utils';
import language from './language';
import search from './search';
import changeNum from './change-num';
import slick from './slider-slick';
import magnificPopup from './popup-gallery';
import matchHeight from './match-height';
import accordionToTabs from './accordion';
import sumoSelect from './sumo-select';
import inputFile from './upload-file';
import prettyCheckable from './pretty-checkable';
import infinite from './infinite-scroll';
import formh from './formh';
import initMap from './maps';

 
slick();
matchHeight(); 
utils();
language();
changeNum();
search();
magnificPopup();
accordionToTabs();
sumoSelect();
inputFile();
prettyCheckable();
infinite();
formh();
initMap();


// WEBPACK FOOTER //
// ./src/assets/js/main.js